import { useDispatch, useSelector } from "react-redux";
import { addBuilding } from "../services/buildingAddService";
import { fetchBuildings } from "../../../../../redux/buildings/buildingsSlice";
import {
  selectCurrentPage,
  selectRowsPerPage,
} from "../../../../../redux/buildings/buildingsPaginationSlice";
import { initialBuildingFormData } from "../config/formDataConfig";

const useAddBuilding = () => {
  const dispatch = useDispatch();
  const currentPage = useSelector(selectCurrentPage);
  const rowsPerPage = useSelector(selectRowsPerPage);

  // Helper function to create a building object with defaults.
  const initialBuildingWithDefaults = () => ({
    ...initialBuildingFormData,
    buildingStatus: "Active", // Set default status to "Active"
  });

  const createNewBuilding = async () => {
    try {
      const initialBuilding = initialBuildingWithDefaults();
      const newBuilding = await addBuilding(initialBuilding);
      // Re-fetch buildings using current pagination values
      dispatch(fetchBuildings({ currentPage, rowsPerPage, searchQuery: "" }));
      return newBuilding;
    } catch (error) {
      console.error("Error adding building:", error);
      return null;
    }
  };

  return createNewBuilding;
};

export default useAddBuilding;
